define('views/content/go_order_license',['require','backbone','marionette','jquery-validation','text!templates/content/go_order_license.html'],function (require) {
  var Backbone = require("backbone");
  require("marionette");
  require("jquery-validation");

  var temp = require("text!templates/content/go_order_license.html");

  return Backbone.Marionette.LayoutView.extend({
    template: _.template(temp),
    className: "license-info-detail-page page",
    titleKey: "license_info_details",
    info_list: [],

    initialize: function () {
      var _this = this;

      App.context.changePageTitle(App.polyglot.t(this.titleKey));

      this.url = App.Config.apiBase + "license-info/" + this.id + "/";

      $.ajax({
        url: this.url,
        type: "GET",
        success: function (response) {
          _this.info_list = response.info_list;
          _this.is_new = response.is_new;
          _this.render();
        },
        error: function (response) {
          // Show error messages
          if (response.responseJSON.errors) {
            for (var i = 0; i < response.responseJSON.errors.length; i++) {
              App.utils.showMessage(
                "error",
                response.responseJSON.errors[i].message
              );
            }
          }
        },
      });
    },

    ui: function () {
      return {
        mainForm: "#main-form",
        submitButton: "#license-info-save-button",
      };
    },

    events: {
      "click @ui.submitButton": "submitButtonClicked",
    },

    submitButtonClicked: function () {
    
      if (this.ui.mainForm.valid()) {
        var _this = this;
        var formData = {};

        _this.ui.submitButton.addClass('loading');

        this.ui.mainForm.serializeArray().forEach((data) => {
          formData[data.name]=data.value;
        });

        
        $.ajax({
          url: this.url,
          type: "POST",
          data: formData,
          success: function (response) {
            _this.ui.submitButton.removeClass('loading');

            App.utils.showMessage("success", App.polyglot.t("save_success"));

            new_info_list = [];

            Object.entries(response).forEach(([key,value])=>{
              new_info_list.push({key, value});
            });

            _this.info_list = new_info_list;
            _this.is_new= false;
            _this.render();
          },
          error: function (response) {
            _this.ui.submitButton.removeClass('loading');

            // Show error messages
            if (response.responseJSON.errors) {
              for (var i = 0; i < response.responseJSON.errors.length; i++) {
                App.utils.showMessage(
                  "error",
                  response.responseJSON.errors[i].message
                );
              }
            }
            
          },
        });
      }
    },

    labelFormatter: function (str) {
      return str.replace(/[.\-_]/g, " ");
    },

    templateHelpers: function () {
      return {
        info_list: this.info_list,
        is_new: this.is_new,
        labelFormatter: this.labelFormatter,
      };
    },
  });
});

